/**
 * this component will display the card summary information
 *
 * @module views/components/ProductFulfillmentOptions
 * @memberof -Common
 */
import './ProductFulfillmentOptions.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '@ulta/core/components/Button/Button';
import Icon from '@ulta/core/components/Icon/Icon';
import Text from '@ulta/core/components/Text/Text';
import { hasItems } from '@ulta/core/utils/array/array';

import * as utils from './ProductFulfillmentOptions';
/**
 * Represents a ProductFulfillmentOptions component
 *
 * @method
 * @param {ProductFulfillmentOptionsProps} props - React properties passed from composition
 * @returns ProductFulfillmentOptions
 */

export const ProductFulfillmentOptions = function( props ){
  const { items, layout, config = {} } = props;
  if( !hasItems( items ) ){
    return null;
  }

  return (
    <div className='ProductFulfillmentOptions' >
      <ul
        className={ classNames( 'ProductFulfillmentOptions__listWrapper', {
          ...( layout && { [`ProductFulfillmentOptions--${layout}`]: layout } )
        } ) }
      >
        {
          items.map( ( item, index ) => (
            <li key={ index } >
              <span className='ProductFulfillmentOptions__listItemIcon'>
                <Icon size={ 'l' }
                  name={ item.icon }
                  aria-hidden={ true }
                />
              </span>
              { item?.action && (
                <Button
                  likeLink
                  label={ item.action.label }
                  action={ utils.getActions( { action: item.action, config } ) }
                  crossButtonVisibility={ false }
                />
              ) }
              { !item.action && (
                <Text htmlTag='span'
                  textStyle='body-2'
                  textAlign='left'
                >
                  { item.message }
                </Text>
              ) }
            </li>
          ) )
        }
      </ul>
    </div>
  );
};

/**
 * Method to return action object for triggerring mutation event
 * @param {object} data - DXL action object product configurations to create mutation query
 */
export const getActions = ( data ) => {
  const { action, config } = data;
  return {
    ...action,
    variables: config
  };
};


/**
 * Property type definitions
 * @typedef ProductFulfillmentOptionsProps
 * @type {object}
 * @property {string} type - Sets value for the type
 * @property {string} icon - Sets value for an icon
 * @property {string} title - Sets value for the title
 * @property {object} items - Array of items required for summary card
 * @property {string} layout - Sets value for the layout
 */
export const propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape( {
      icon: PropTypes.string,
      message: PropTypes.string
    } )
  ),
  layout: PropTypes.string.isRequired
};

ProductFulfillmentOptions.propTypes = propTypes;

export default ProductFulfillmentOptions;
